import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, computed, EventEmitter, HostListener, inject, Input, input, Output, ViewEncapsulation } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { Store } from '@ngrx/store';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { RecordHttpActions } from '@src/suite/common/store/records/records.actions';

@Component({
    selector: 'st-assignment-condensed',
    templateUrl: './st-assignment-condensed.html',
    styleUrls: ['./st-assignment-condensed.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-assignment-condensed',
    },
})
export class StAssignmentCondensedComponent extends EnpsComponent {
    store = inject(Store);
    globalTablesService = inject(GlobalTablesService);

    data = input<StorytellingAssignmentRecord>();
    isReadOnly = input(false, {
        transform: coerceBooleanProperty,
    });
    pstFieldNames = PSTFieldNames;

    private _isPublication: boolean = false;
    @Input()
    public get isPublication(): boolean {
        return this._isPublication;
    }
    public set isPublication(v: boolean) {
        this._isPublication = v;
    }
    @Output() public deletePublicationEmitter: EventEmitter<any> = new EventEmitter();
    @Output() public assignmentOpenEmitter: EventEmitter<StorytellingAssignmentRecord> = new EventEmitter();

    @HostListener('click')
    public onClick() {
        if (this.isReadOnly()) {
            return;
        }
        this.assignmentOpenEmitter.emit(this.data());
    }

    get timeUpdatedLabel(): string {
        return `${this.data()?.ModTime?.moment?.fromNow()}`;
    }

    assignmentDescription = computed(() => {
        return this.data()?.Description ? this.data().Description : this.globalTablesService.FieldDefsDict[this.pstFieldNames.Description]?.DefaultCaption;
    });

    assignmentDesks = computed(() => {
        return this.data()?.PSTGroup?.join(', ');
    });

    updateAssignment(value: any, fieldId: string) {
        const fieldDef = [{ value, key: fieldId }];
        // TODO: not cool to have this title logic here
        if (fieldId === PSTFieldNames.Title) {
            this.data().Title = value.trim();
            this.data().Slug = value.trim();
            fieldDef.push({ value: value, key: PSTFieldNames.Slug });
        }
        this.store.dispatch(RecordHttpActions.saveRecordChanges({ record: this.data(), fieldsToUpdate: fieldDef }));
    }

    public deletePublication(event: any) {
        event.stopPropagation();
        this.deletePublicationEmitter.emit();
    }
}
